export function normalizePartnerUserActivity (useractivity = '') {
  const activity = String(useractivity || '').trim().toLowerCase()

  if (activity === 'business associate' || activity === 'los 1' || activity === 'los 2') {
    return 'business associate'
  }

  if (activity === 'associate partner') {
    return 'associate partner'
  }

  return 'company associate partner'
}

export function channelPartnerAgreementTitle (useractivity = '') {
  const normalized = normalizePartnerUserActivity(useractivity)

  if (normalized === 'business associate') {
    return 'Business Associate Agreement'
  }

  if (normalized === 'associate partner') {
    return 'Associate Partner Agreement'
  }

  return 'Company Associate Partner Agreement'
}

export function channelPartnerAgreementLabel (useractivity = '') {
  const normalized = normalizePartnerUserActivity(useractivity)

  if (normalized === 'business associate') {
    return 'Business Associate'
  }

  if (normalized === 'associate partner') {
    return 'Associate Partner'
  }

  return 'Company Associate Partner'
}
